<template>
  <el-dialog
    ref="updateDialogRef"
    :title="$t('Fee.UpdateBeneficiaryAccount')"
    :visible="dialogVisible"
    :close-on-click-modal="false"
    :lock-scroll="true"
    center
    :show-close="false"
    @closed="closed"
  >
    <canvas ref="watermarkCanvas"></canvas>
    <div class="step">
      <div class="step-title">{{ $t('Fee.UpdateBeneficiaryAccountStep[0]') }}</div>
      <div v-if="!passbookImgUrl" class="step-hint">{{ $t('Fee.UpdateBeneficiaryAccountStepHint[0]') }}</div>
      <input ref="uploadPassbookInput" style="display: none;" type="file" :accept="passbookImgTypes.join(',')" @change="uploadPassbookChange"></input>
      <div class="btn-wrap">
        <span v-if="passbookImgUrl" class="preview" :class="{ 'is-pdf': !passbookImg.type.includes('image') }">
          <img v-if="passbookImg.type.includes('image')" :src="passbookImgUrl" @click="coolLightBoxData.index = 0"></img>
          <span v-else class="pdf-name">
            {{ passbookImg.name }}
          </span>
        </span>
        <el-button
          size="mini"
          type="primary"
          :loading="isUploadLoading"
          @click="uploadPassbook"
        >
          {{ isUploadLoading ? $t('Fee.UploadingPassbook', { sec: uploadingSec }) : passbookImgUrl ? $t('Fee.ReUploadPassbook') : $t('Fee.UploadPassbook') }}
        </el-button>
      </div>
    </div>
    <div class="step">
      <div class="step-title">{{ $t('Fee.UpdateBeneficiaryAccountStep[1]') }}</div>
      <div class="step-hint">{{ $t('Fee.UpdateBeneficiaryAccountStepHint[1]') }}</div>
      <el-form ref="accountForm" label-position="right" label-width="120px" :model="accountForm" :rules="accountFormRule" :disabled="!passbookImg || isSubmitLoading || isUploadLoading">
        <el-form-item :label="$t('Fee.BankNumber')" prop="bankNumber">
          <el-input v-model="accountForm.bankNumber" maxlength="7"></el-input>
        </el-form-item>
        <el-form-item :label="$t('Fee.Account')" prop="account">
          <el-input v-model="accountForm.account" maxlength="16"></el-input>
        </el-form-item>
        <el-form-item :label="$t('Fee.AccountName')" prop="accountName">
          <el-input v-model="accountForm.accountName" maxlength="39"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <!-- 暫時性移除 -->
    <!-- <div class="step">
      <div class="step-title">{{ $t('Fee.UpdateBeneficiaryAccountStep[2]') }}</div>
      <div class="step-hint">{{ $t('Fee.UpdateBeneficiaryAccountStepHint[2]') }}</div>
      <div class="btn-wrap">
        <el-button
          size="mini"
          type="primary"
          @click="downloadAgreement"
        >
          {{ $t('Fee.DownloadAgreement') }}
        </el-button>
      </div>
    </div> -->
    <CoolLightBox
      :items="coolLightBoxData.item"
      :index="coolLightBoxData.index"
      @close="coolLightBoxData.index = null"
    />
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        round
        @click="back"
      >
        {{ $t('General.Cancel') }}
      </el-button>
      <el-button
        type="primary"
        round
        :loading="isSubmitLoading"
        :disabled="isSubmitDisabled"
        @click="submit"
      >
        {{ isSubmitDisabled ? $t('Fee.UpdateBeneficiaryAccountSubmitDisabled') : $t('Fee.UpdateBeneficiaryAccountSubmit') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import axios from 'axios'
import { imageFileToBase64, getImageData, qualityFile } from '@/js/utils/image.js'
export default {
  props: {
    dialogVisible: Boolean
  },
  data () {
    const numberValidator = (rule, value, callback) => {
      if (value && !(/^\d+$/.test(value))) {
        callback(new Error(this.$t('Fee.PleaseEnter', { name: this.$t('Fee.Number') })))
      } else {
        callback()
      }
    }
    return {
      passbookImgTypes: ['image/png', 'image/jpeg', 'application/pdf'],
      passbookImg: null,
      passbookImgUrl: '', // 會有浮水印
      accountForm: {
        bankNumber: '',
        account: '',
        accountName: ''
      },
      accountFormRule: {
        bankNumber: [
          { required: true, message: this.$t('Fee.PleaseEnter', { name: this.$t('Fee.BankNumber') }), trigger: 'blur' },
          { max: 7, message: this.$t('Fee.MaxLength', { number: 7 }), trigger: 'blur' },
          { validator: numberValidator, trigger: 'blur' }
        ],
        account: [
          { required: true, message: this.$t('Fee.PleaseEnter', { name: this.$t('Fee.Account') }), trigger: 'blur' },
          { max: 16, message: this.$t('Fee.MaxLength', { number: 16 }), trigger: 'blur' },
          { validator: numberValidator, trigger: 'blur' }
        ],
        accountName: [
          { required: true, message: this.$t('Fee.PleaseEnter', { name: this.$t('Fee.AccountName') }), trigger: 'blur' },
          { max: 39, message: this.$t('Fee.MaxLength', { number: 39 }), trigger: 'blur' }
        ]
      },
      coolLightBoxData: {
        item: [],
        index: null
      },
      isUploadLoading: false,
      isSubmitLoading: false,
      passbookId: '',
      uploadingSec: 30,
      recognizePassbookCancelTokenSource: null
    }
  },
  computed: {
    isSubmitDisabled () {
      return !this.accountForm.bankNumber || !this.accountForm.account || !this.accountForm.accountName
    }
  },
  watch: {
    passbookImgUrl () {
      this.coolLightBoxData.item = [{ src: this.passbookImgUrl }]
    }
  },
  methods: {
    back () {
      this.$emit('back')
      // 若開啟下個彈窗及關閉此彈窗同時進行，會發生 backdrop 閃一下的狀況
      this.$nextTick(() => { this.close() })
    },
    close () {
      this.$emit('close')
      const body = this.$refs.updateDialogRef?.$el.querySelector('.el-dialog__body')
      if (body) body.scrollTop = 0
    },
    closed () {
      if (this.recognizePassbookCancelTokenSource) this.recognizePassbookCancelTokenSource.cancel()
      this.$refs.uploadPassbookInput.value = ''
      this.passbookImg = null
      this.passbookImgUrl = ''
      this.$refs.accountForm.resetFields()
    },
    uploadPassbook () {
      this.$refs.uploadPassbookInput.click()
    },
    async uploadPassbookChange (e) {
      const { target } = e
      const { files } = target
      if (files.length <= 0) return
      const file = files[0]
      if (!this.passbookImgTypes.includes(file.type)) {
        this.$message.error(this.$t('Fee.UploadFail'))
        return
      }
      this.uploadingSec = 30
      const uploadingSecInterval = setInterval(() => {
        this.uploadingSec--
        if (this.uploadingSec <= 0) clearInterval(uploadingSecInterval)
      }, 1000)
      this.isUploadLoading = true
      const newFile = file.type.includes('image') ? await qualityFile(file) : file
      await this.recognizePassbook(newFile)
      this.isUploadLoading = false
      clearInterval(uploadingSecInterval)
      this.$refs.uploadPassbookInput.value = ''
    },
    async recognizePassbook (file) {
      try {
        const passbookId = await this.getPassbookId(file)
        if (!passbookId) return
        const cancelToken = axios.CancelToken
        this.recognizePassbookCancelTokenSource = cancelToken.source()
        const res = await apiBillserviceKGI.Config.RecognizePassbook({ Id: passbookId }, this.recognizePassbookCancelTokenSource.token)
        if (res?.data) {
          if (res.data.Confidence < 0.5) {
            this.$alert(
              this.$t('Fee.UploadVagueBody'),
              this.$t('Fee.UploadVagueTitle'),
              {
                confirmButtonText: this.$t('General.OK')
              }
            )
            return
          }
          this.$refs.accountForm.resetFields()
          this.accountForm.bankNumber = res.data.BankCode || ''
          this.accountForm.account = res.data.BankAccount || ''
          this.accountForm.accountName = res.data.BankAccountName || ''
          if (res.data.BankCode && res.data.BankAccount && res.data.BankAccountName) {
            this.$alert(
              this.$t('Fee.UploadSuccessAndHaveResponseContent'),
              this.$t('Fee.UploadSuccessTitle'),
              {
                confirmButtonText: this.$t('General.OK')
              }
            )
          } else {
            this.$alert(
              this.$t('Fee.UploadSuccessAndNotHaveResponseContent'),
              this.$t('Fee.UploadSuccessTitle'),
              {
                confirmButtonText: this.$t('General.OK')
              }
            )
          }
        }
        this.passbookImg = file
        this.passbookId = passbookId
        if (file.type.includes('image')) await this.addWatermark(file)
        else this.passbookImgUrl = await imageFileToBase64(file)
        return true
      } catch (e) {
        if (!axios.isCancel(e)) {
          this.$message.error(this.$t('Fee.UploadFail'))
        }
        return false
      }
    },
    async addWatermark (file) {
      try {
        const watermarkCanvas = this.$refs.watermarkCanvas
        if (!watermarkCanvas) throw new Error('not found watermarkCanvas')
        const passbookImgUrl = await imageFileToBase64(file)
        const { img, width, height } = await getImageData(passbookImgUrl)
        watermarkCanvas.width = width
        watermarkCanvas.height = height
        const ctx = watermarkCanvas.getContext('2d')
        if (!ctx) throw new Error('not found ctx')
        ctx.drawImage(img, 0, 0, width, height)
        const stringColCount = (height / 1.732) * 1.5 + width / 2
        const stringRowCount = (width * 1.732 / 2 + height / 2) / 30
        for (let i = 0; i < stringColCount + 1; i++) {
          ctx.rotate((-30 * Math.PI) / 180)
          let watermarkString = ''
          for (let j = 0; j < stringRowCount + 1; j++) {
            watermarkString += this.$t('Fee.WatermarkText')
          }
          ctx.font = '28px sans-serif'
          ctx.fillStyle = '#E0E0E050'
          ctx.fillText(watermarkString, -(height / 1.732), i * 50)
          ctx.rotate((30 * Math.PI) / 180)
        }
        this.passbookImgUrl = watermarkCanvas.toDataURL('image/png')
      } catch (e) {
        console.log(e)
      }
    },
    downloadAgreement () {
      const fileName = '智生活啟用設定增補協議書.pdf'
      const link = document.createElement('a')
      link.href = process.env.NODE_ENV === 'development' ? '/Agreement.pdf' : `${window.location.origin}/mgmt/Agreement.pdf`
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    async getPassbookId (file) { // 上傳圖片取得 ID
      try {
        const formData = new FormData()
        formData.append('File', file)
        const res = await apiBillserviceKGI.Config.PostCommunityPassbookCopy(formData)
        if (res?.data?.Id) return res.data.Id
        else this.$message.error(this.$t('Fee.UploadFail'))
      } catch (e) {
        console.log(e)
        this.$message.error(this.$t('Fee.UploadFail'))
      }
    },
    async submit () {
      try {
        await this.$confirm(this.$t('Fee.ConfirmApply'), '', {
          confirmButtonText: this.$t('General.Confirm'),
          cancelButtonText: this.$t('General.Cancel'),
          closeOnClickModal: false
        })
        this.isSubmitLoading = true
        await this.$refs.accountForm.validate(async (valid) => {
          if (valid) {
            try {
              if (!this.passbookId) return
              const requestData = {
                BankBranchCode: this.accountForm.bankNumber,
                Account: this.accountForm.account,
                AccountName: this.accountForm.accountName,
                PassbookCopyFileId: this.passbookId
              }
              await apiBillserviceKGI.Config.PostCommunityAccount(requestData)
              await this.getAccountConfig()
              this.nextStep()
            } catch (e) {
              console.log(e)
              this.$message.error(this.$t('Server.TryAgainLater'))
            }
          }
        })
        this.isSubmitLoading = false
      } catch (e) { /** 不處理 */ }
    },
    async getAccountConfig () { // 取得社區帳號設定檔
      try {
        const res = await apiBillserviceKGI.Config.GetCommunityAccount()
        if (res.data) {
          this.$store.commit('setFeeAccountConfig', res.data)
        }
      } catch (e) {
        console.log(e)
      }
    },
    nextStep () {
      this.$emit('nextStep')
      // 若開啟下個彈窗及關閉此彈窗同時進行，會發生 backdrop 閃一下的狀況
      this.$nextTick(() => { this.close() })
    }
  }
}
</script>

<style lang="scss" scoped>
canvas {
  display: none;
}
::v-deep .el-dialog__body {
  & > .step:not(:last-child) {
    margin-bottom: 20px;
  }
}
::v-deep .el-button .el-icon-loading {
  padding: unset;
}
.step {
  padding: 20px 25px;
  background-color: $bgDark4;
  ::v-deep .el-form {
    padding-left: 20px;
    margin-top: 22px;
  }
  ::v-deep .el-form-item__label {
    margin-right: 0 !important;
    line-height: 40px !important;
  }
  ::v-deep .el-form-item__content {
    max-width: 450px;
  }
  .step-title {
    font-size: map-get($fontSize, large);
    font-weight: bold;
    color: $mainFontColor;
    margin-bottom: 15px;
  }
  .step-hint {
    color: $warnColor;
    padding-left: 20px;
    line-height: 20px;
  }
  .btn-wrap {
    display: flex;
    align-items: end;
    padding-left: 20px;
    margin-top: 15px;
    .preview {
      margin-right: 20px;
      &.is-pdf {
        align-self: center;
      }
      img {
        cursor: pointer;
        width: 120px;
      }
      .pdf-name {
        padding: 7px 40px;
        border-radius: 6px;
        background-color: $bgDark2;
        color: $grayFontColor;
      }
    }
  }
}
</style>
